import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { Stack } from '@mui/material';
import CustomIconButton from 'common/components/CustomIconButton';
import useFlexBoxStyles from 'common/flexBox';
import { useCallback, useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import ReactDOM from 'react-dom';
import ScrollContainer from 'react-indiana-drag-scroll';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        arrowCarrousel: {
            top: '40%',
        },
    };
});

const EventItemCarousel = (props) => {
    const { children, upcomingLength } = props;
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const [showBack, setShowBack] = useState(false);
    const [showForward, setShowForward] = useState(false);
    const ref = useRef();

    const getCoords = () => ({
        realPos: ref.current.container.current.scrollLeft,
        scrollWidth: ref.current.container.current.scrollWidth,
        clientWidth: ref.current.container.current.clientWidth,
    });

    const getScrollOption = (newPos) => ({ top: 0, left: newPos, behavior: 'smooth' });
    const scroll = (newPos) => ReactDOM.findDOMNode(ref.current).scrollTo(getScrollOption(newPos));

    const onEndScroll = useCallback(() => {
        const c = getCoords();
        setShowBack(Boolean(c.realPos > 0));
        setShowForward(Boolean(c.scrollWidth - c.clientWidth > c.realPos));
    }, []);

    const backScroll = () => {
        const c = getCoords();
        const newPos = c.realPos - c.clientWidth / 2;
        scroll(newPos >= 0 ? newPos : 0);
    };

    const forwardScroll = () => {
        const c = getCoords();
        const newPos = c.realPos + c.clientWidth / 2;
        scroll(newPos <= c.scrollWidth - c.clientWidth ? newPos : c.scrollWidth - c.clientWidth);
    };

    useEffect(() => {
        onEndScroll();
    }, [upcomingLength, onEndScroll]);

    return (
        <Stack direction="row" className={flexBox.relative}>
            {!isMobile && showBack && (
                <Stack
                    direction="row"
                    alignItems="center"
                    className={cx(classes.arrowCarrousel, flexBox.absolute, flexBox.zIndex2, flexBox.left0)}
                >
                    <CustomIconButton onClick={backScroll}>
                        <ArrowBackIosOutlinedIcon />
                    </CustomIconButton>
                </Stack>
            )}
            <ScrollContainer
                onEndScroll={onEndScroll}
                ref={ref}
                nativeMobileScroll={isMobile}
                hideScrollbars={true}
                horizontal={true}
                className={cx(flexBox.flex, flexBox.gap3, flexBox.paddingBottom05, flexBox.paddingTop05, flexBox.w100)}
            >
                {children}
            </ScrollContainer>

            {!isMobile && showForward && (
                <Stack
                    direction="row"
                    alignItems="center"
                    className={cx(classes.arrowCarrousel, flexBox.absolute, flexBox.zIndex2, flexBox.right0)}
                >
                    <CustomIconButton onClick={forwardScroll}>
                        <ArrowForwardIosOutlinedIcon />
                    </CustomIconButton>
                </Stack>
            )}
        </Stack>
    );
};

export default EventItemCarousel;
